import { useQuery } from "@tanstack/react-query";
import useWidgetStore from "../../../store/useWidgetStore";
import ConfigHolder from "../../../config/ConfigHolder";
import { prepareUrl } from "../../../context/WidgetContext";
import { useSettings } from "../../../context/SettingsContext";
export const useApptypes = (options) => {
    const { api_key, widget_id } = useSettings();
    const { enabled } = useWidgetStore();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: enabled.apptype, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-apptype'], 
        // only remaining porting issue(s):
        // API returns all apptypes, while the old API only returns apptypes that are bookable
        // queryFn: async ({ signal }) => {
        //     let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'appTypes', 'core')
        //     const response = await fetch(url.href, {
        //         signal: signal,
        //         headers: {
        //             'accept': 'application/ld+json',
        //         }
        //     })
        //     return response.json()
        // }
        queryFn: async ({ signal }) => {
            let url = new URL(`/consumer/booking/api/method/getApptypes`, ConfigHolder.apiBaseUrl);
            url = prepareUrl(url, 'getApptypes', api_key, widget_id, {
                filter_apptype: '',
                filter_resource: ''
            });
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
